$(document).ready(function() {
    if ($('body.product-template-default').length > 0) {
        productWarranty();
        productSummary();
        leasingCalculator();
    }
});

function productWarranty() {
    $('.warranty_info select').select2({
        minimumResultsForSearch: Infinity
    });
}

function productSummary() {
    var summaryWrapper = $('.footer-product-summary');

    $(window).scroll(function() {
        if ($(this).scrollTop() > 300) {
            summaryWrapper.removeClass('hide');
        } else {
            summaryWrapper.addClass('hide');
        }
    });
}

function leasingCalculator() {
    var leasingContainer = $('.leasing_calculator');

    var trigger = leasingContainer.find('.dropdown-header');

    trigger.on('click', function () {
        var leasingContainer = $(this).parents('.leasing_calculator');
        var dropdown = $(this).parents('.leasing_calculator').find('.dropdown-content');

        if (leasingContainer.hasClass('active')) {
            leasingContainer.removeClass('active');
            dropdown.slideUp({duration: 400});
        } else {
            leasingContainer.addClass('active');
            dropdown.slideDown({duration: 400});
        }
    });
}